/**
 * Detección de capacidad para slab MPR 2D (Lite vs Pro).
 * Reutiliza getResourceHints; WebGL2 solo informa, no habilita GPU 2D.
 */
import { getResourceHints } from './mobileDownloadProfile'
import { hasWebGl } from './mpr3dProfile'

export function hasWebGl2() {
  if (typeof document === 'undefined') return false
  try {
    const c = document.createElement('canvas')
    return !!(c.getContext && c.getContext('webgl2'))
  } catch (e) {
    return false
  }
}

export function detectHardware(hints) {
  const h = hints || getResourceHints()
  return {
    hw: h.hw,
    deviceMemory: h.deviceMemory,
    phone: !!h.phone,
    constrained: !!h.constrained,
    webgl: hasWebGl(),
    webgl2: hasWebGl2(),
  }
}

/**
 * @param {object} [hints]
 * @param {'full'|'light'|'blocked'} [mprProfile]
 * @returns {{ tier: 'off'|'lite'|'pro', maxHalfWidth: number, thinOnInteract: boolean }}
 */
export function resolveSlabProfile(hints, mprProfile) {
  if (mprProfile === 'blocked') {
    return { tier: 'off', maxHalfWidth: 0, thinOnInteract: true }
  }
  const h = hints || getResourceHints()
  if (h.phone || h.constrained || mprProfile === 'light') {
    return { tier: 'lite', maxHalfWidth: 2, thinOnInteract: true }
  }
  return { tier: 'pro', maxHalfWidth: 12, thinOnInteract: true }
}
